const html = document.querySelector('html');
// banquetページ
const modalImageElement = [...document.querySelectorAll('.p-banquet-layout__style-image img')];
const modalImageSrc = modalImageElement.map(e => e.getAttribute('src'));
const modalOverlay = document.querySelector('.p-modal-image-only__overlay');
const modal = document.querySelector('.p-modal-image-only');
const modalClose = document.querySelector('.p-modal-image-only__close');
let modalImage = document.querySelector('.p-modal-image-only__image');

modalImageElement.forEach((e, index) => {
  e.addEventListener('click', () => {
    html.style.overflow = 'hidden';
    modal.classList.add('is-open');
    modalImage.setAttribute('src', modalImageSrc[index]);
  })
})

if(modalOverlay) {
  modalOverlay.addEventListener('click', () => {
    modal.classList.remove('is-open');
    html.style.overflow = '';
  })
}

if(modalClose){
  modalClose.addEventListener('click', () => {
    modal.classList.remove('is-open');
    html.style.overflow = '';
  })
}

// フロアガイドページ
const floorGuideModalOpen = document.querySelector('.p-floor-guide-map__modal-open');
const floorGuideMapImage = document.querySelector('.p-floor-guide-map__image img');
let floorGuideMapImageSrc;
if(floorGuideMapImage) {
  floorGuideMapImageSrc = floorGuideMapImage.getAttribute('src');
}

if(floorGuideModalOpen) {
  floorGuideModalOpen.addEventListener('click', () => {
    html.style.overflow = 'hidden';
    modal.classList.add('is-open');
    modalImage.setAttribute('src', floorGuideMapImageSrc);
  })
}